if (!customElements.get('linked-product-add')) {
  customElements.define(
    'linked-product-add',
    class LinkedProductAdd extends HTMLElement {
      connectedCallback() {
        this.enabled = this.dataset.linkedProductEnabled === 'true';
        this.linkedVariantId = this.dataset.linkedVariantId;

        if (!this.enabled || !this.linkedVariantId) return;

        this.addSources = ['product-form', 'sticky-atc'];

        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (!this.addSources.includes(event.source)) return;
          this.maybeAddLinkedProduct();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
      }

      async maybeAddLinkedProduct() {
        try {
          const cartResponse = await fetch(`${routes.cart_url}.js`);
          const cart = await cartResponse.json();

          const alreadyInCart = cart.items.some(
            (item) => item.variant_id === parseInt(this.linkedVariantId, 10)
          );
          if (alreadyInCart) return;

          const cartDrawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          const sections = cartDrawer && cartDrawer.getSectionsToRender
            ? cartDrawer.getSectionsToRender().map((s) => s.id)
            : [];

          const response = await fetch(`${routes.cart_add_url}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: this.linkedVariantId, quantity: 1 }],
              sections,
              sections_url: window.location.pathname,
            }),
          });

          if (!response.ok) return;
          const addResult = await response.json();

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'linked-product-add',
            cartData: addResult,
            variantId: this.linkedVariantId,
          });
        } catch (error) {
          console.error('linked-product-add: failed to sync linked product', error);
        }
      }
    }
  );
}